function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gate",
    id: "Gate-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.269,25.7965h3.25V10.1705h.936V7.3235h-.936V5.6985a1.617,1.617,0,0,0-.975-1.482v-1.17h-1.3v1.17a1.617,1.617,0,0,0-.975,1.482v1.625h-.936v2.847h.936v4.732a8.1639,8.1639,0,0,0-7.501-7.878v3.627a5.7123,5.7123,0,0,1,0,10.79v2.509h7.501Z",
    style: {
      fill: "inherit"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.572 27.096 24.229 27.096 23.28 28.644 30.508 28.644 29.572 27.096",
    style: {
      fill: "inherit"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2.428 27.096 1.492 28.644 8.72 28.644 7.771 27.096 2.428 27.096",
    style: {
      fill: "inherit"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.731,15.1625v-4.992h.936V7.3235H6.731V5.6985a1.617,1.617,0,0,0-.975-1.482v-1.17h-1.3v1.17a1.617,1.617,0,0,0-.975,1.482v1.625H2.545v2.847h.936v15.626h3.25v-1.846h7.501v-2.392a5.7468,5.7468,0,0,1,0-11.024v-3.51A8.1716,8.1716,0,0,0,6.731,15.1625Z",
    style: {
      fill: "inherit"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.101,16.0465a2.7584,2.7584,0,0,0,1.131,2.236v-4.459A2.7342,2.7342,0,0,0,13.101,16.0465Z",
    style: {
      fill: "inherit"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.411,16.0465a4.4711,4.4711,0,0,0,2.821,4.147v-.429a4.0587,4.0587,0,0,1,0-7.436V11.9A4.4711,4.4711,0,0,0,11.411,16.0465Z",
    style: {
      fill: "inherit"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.303,16.0465a4.4245,4.4245,0,0,0-2.535-4.004v.442a4.0408,4.0408,0,0,1,0,7.137v.429A4.4245,4.4245,0,0,0,20.303,16.0465Z",
    style: {
      fill: "inherit"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.768,14.0575v3.991a2.7787,2.7787,0,0,0,0-3.991Z",
    style: {
      fill: "inherit"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGateIcon);
export default __webpack_public_path__ + "static/media/GateIcon.af49ac04e0e61bd5fd6f96d11f4bf5d5.svg";
export { ForwardRef as ReactComponent };